module.exports = __webpack_public_path__ + "Flama-BasicItalic.woff?4b41ebc8b7dd8ad91488bf23831238fa";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BasicItalic.woff
// module id = 888
// module chunks = 0